interface SelectionListProps {
  options: {
    label: React.ReactNode;
    value: string;
    data: any;
  }[];
  containerClass?: string;
  onChange: (option: {
    label: React.ReactNode;
    value: string;
    data: any;
  }) => void;
  defaultValue?: string;
}

const SelectionList: React.FC<SelectionListProps> = ({
  containerClass = "flex-col gap-4 cursor-pointer",
  options,
  onChange,
}) => {
  return (
    <div className={containerClass}>
      {options &&
        options?.map((option) => (
          <>
            <div
              key={option?.value}
              onClick={() => onChange(option)}
              className="py-4 hover:bg-brightPurple  cursor-pointer rounded-lg"
            >
              {option?.label}
            </div>
            <div className="border-b-2 border-color-gray-100" />
          </>
        ))}
    </div>
  );
};

export default SelectionList;
